<template>
  <div class="about-us-slider-item">
    <div class="about-us-slider-member">
      <img
        class="about-us-slider-member__image"
        src="/local/templates/main/img/about-us/about-us-slide.png"
        alt="about-us-slide"
      >
      <h4 class="about-us-slider-member__name">
        Алия Махтар
      </h4>
      <p class="about-us-slider-member__position">
        Волонтер компании Omega
      </p>
    </div>
    <div class="about-us-slider-content">
      <p>
        Наша команда — это профессионалы, отвечающие за развитие фонда и качественное выполнение задач. Сотрудники имеют
        разные зоны ответственности: административное управление, подготовка, контроль.
      </p>
      <p>
        Правление — орган, принимающий ключевые стратегические решения фонда «Друзья». Фактически это его совет
        директоров.
        В полномочия Правления входят внесение изменений в Устав, выбор приоритетных направлений развития, утверждение
        ключевых партнеров и проектов фонда.🤝🔥
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUsSliderItem',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.about-us-slider-item {
  display: grid;
  grid-template-columns: 1fr 818px;
  grid-column-gap: 50px;
  padding: 92px 105px 55px 87px;
  @include tablet {
    grid-template-columns: 1fr 368px;
    padding: 38px 73px 42px 33px;
  }
  @include mobile {
    grid-template-columns: 1fr;
    grid-row-gap: 28px;
    padding: 31px 10px 90px 25px;
  }
}

.about-us-slider-member {
  &__image {
    display: block;
    margin-bottom: 24px;
    max-width: 100px;
    @include mobile {
      margin-bottom: 11px;
      max-width: 50px;
    }
  }

  &__name {
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #252425;
    margin-bottom: 3px;
  }

  &__position {
    font-size: 14px;
    line-height: 20px;
    color: #6367A7;
    margin-bottom: 0;
  }
}

.about-us-slider-content {
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 22px;
  line-height: 32px;
  @include tablet {
    font-size: 14px;
    line-height: 20px;
  }

  p:last-child {
    margin-bottom: 0;
  }
}
</style>